import React from "react";
import * as palette from "@govlaunch/palette";

export default function Typeform({ attributes, element, children }) {
  const { src } = element;
  const typeformEmbed = require("@typeform/embed");

  const reference = typeformEmbed.makePopup(src, {
    mode: "popup",
    autoClose: 3000,
    hideHeaders: true,
    hideFooters: true,
  });

  return (
    <div {...attributes}>
      <div
        css={{
          display: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
      <div contentEditable={false}>
        <div
          css={{
            position: "relative",
            marginTop: 10,
          }}
        >
          <button
            type="button"
            css={{
              border: "none",
              padding: 10,
              paddingLeft: 20,
              paddingRight: 20,
              borderRadius: 8,
              fontSize: 14,
              textAlign: "center",
              outline: 0,
              cursor: "pointer",
              backgroundColor: palette.innovatorBlue,
              textTransform: "uppercase",
              color: palette.white,
            }}
            onClick={() => {
              if (reference) {
                reference.open();
              }
            }}
          >
            Launch and Answer
          </button>
        </div>
      </div>
    </div>
  );
}
